import { createSlice } from "@reduxjs/toolkit"
import { getInboundShipments } from "../../../services/SupplyDetails"



const initialState = {
  status: '',
  data: [],
}

export const inboundShipmentsSlice = createSlice({
  name: 'inboundShipments',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInboundShipments.pending, state => { state.status = 'pending' })
      .addCase(getInboundShipments.fulfilled, (state, action) => { state.status = 'fulfilled'; state.data = action.payload; })
      .addCase(getInboundShipments.rejected, state => { state.status = 'failed' })
  },
  selectors: {
    getInboundShipmentsStatus: state => state.status,
    getInboundShipmentData: state => state.data
  }
})

export default inboundShipmentsSlice.reducer;

export const { getInboundShipmentsStatus, getInboundShipmentData } = inboundShipmentsSlice.selectors;